"use client";
"use strict";
import { __module as q } from "./index.es289.js";
import { __require as de } from "./index.es290.js";
import { __require as pe } from "./index.es285.js";
import he from "react";
import { __require as _e } from "./index.es291.js";
import { __require as me } from "./index.es292.js";
import { __require as ve } from "./index.es293.js";
import { __require as Ee } from "./index.es294.js";
import { __require as be } from "./index.es295.js";
import { __require as ge } from "./index.es296.js";
import { __require as we } from "./index.es297.js";
import { __require as qe } from "./index.es298.js";
import { __require as ye } from "./index.es299.js";
import { __require as Re } from "./index.es300.js";
import { __require as Pe } from "./index.es301.js";
var I;
function Ke() {
  return I ? q.exports : (I = 1, (function(K, p) {
    "use client";
    Object.defineProperty(p, "__esModule", {
      value: !0
    });
    function X(n, r) {
      for (var s in r) Object.defineProperty(n, s, {
        enumerable: !0,
        get: r[s]
      });
    }
    X(p, {
      default: function() {
        return ae;
      },
      useLinkStatus: function() {
        return ie;
      }
    });
    const G = /* @__PURE__ */ de(), L = pe(), c = /* @__PURE__ */ G._(he), N = _e(), x = me(), F = ve(), J = Ee(), W = be(), z = ge(), Q = we(), Y = qe(), Z = ye(), $ = Re(), ee = Pe(), T = /* @__PURE__ */ new Set();
    function y(n, r, s, i) {
      if (!(typeof window > "u") && (0, x.isLocalURL)(r)) {
        if (!i.bypassPrefetchedCheck) {
          const l = (
            // Let the link's locale prop override the default router locale.
            typeof i.locale < "u" ? i.locale : "locale" in n ? n.locale : void 0
          ), h = r + "%" + s + "%" + l;
          if (T.has(h))
            return;
          T.add(h);
        }
        n.prefetch(r, s, i).catch((l) => {
          if (process.env.NODE_ENV !== "production")
            throw l;
        });
      }
    }
    function re(n) {
      const s = n.currentTarget.getAttribute("target");
      return s && s !== "_self" || n.metaKey || n.ctrlKey || n.shiftKey || n.altKey || // triggers resource download
      n.nativeEvent && n.nativeEvent.which === 2;
    }
    function te(n, r, s, i, l, h, b, R, g) {
      const { nodeName: P } = n.currentTarget;
      if (P.toUpperCase() === "A" && re(n) || n.currentTarget.hasAttribute("download"))
        return;
      if (!(0, x.isLocalURL)(s)) {
        l && (n.preventDefault(), location.replace(s));
        return;
      }
      n.preventDefault(), (() => {
        if (g) {
          let E = !1;
          if (g({
            preventDefault: () => {
              E = !0;
            }
          }), E)
            return;
        }
        const _ = b ?? !0;
        "beforePopState" in r ? r[l ? "replace" : "push"](s, i, {
          shallow: h,
          locale: R,
          scroll: _
        }) : r[l ? "replace" : "push"](i || s, {
          scroll: _
        });
      })();
    }
    function j(n) {
      return typeof n == "string" ? n : (0, F.formatUrl)(n);
    }
    const oe = /* @__PURE__ */ c.default.forwardRef(function(r, s) {
      let i;
      const { href: l, as: h, children: b, prefetch: R = null, passHref: g, replace: P, shallow: D, scroll: M, locale: _, onClick: E, onNavigate: se, onMouseEnter: C, onTouchStart: k, legacyBehavior: f = !1, ...le } = r;
      i = b, f && (typeof i == "string" || typeof i == "number") && (i = /* @__PURE__ */ (0, L.jsx)("a", {
        children: i
      }));
      const t = c.default.useContext(z.RouterContext), S = R !== !1;
      if (process.env.NODE_ENV !== "production") {
        let o = function(e) {
          return Object.defineProperty(new Error("Failed prop type: The prop `" + e.key + "` expects a " + e.expected + " in `<Link>`, but got `" + e.actual + "` instead." + (typeof window < "u" ? `
Open your browser's console to view the Component stack trace.` : "")), "__NEXT_ERROR_CODE", {
            value: "E319",
            enumerable: !1,
            configurable: !0
          });
        };
        Object.keys({
          href: !0
        }).forEach((e) => {
          if (e === "href" && (r[e] == null || typeof r[e] != "string" && typeof r[e] != "object"))
            throw o({
              key: e,
              expected: "`string` or `object`",
              actual: r[e] === null ? "null" : typeof r[e]
            });
        }), Object.keys({
          as: !0,
          replace: !0,
          scroll: !0,
          shallow: !0,
          passHref: !0,
          prefetch: !0,
          locale: !0,
          onClick: !0,
          onMouseEnter: !0,
          onTouchStart: !0,
          legacyBehavior: !0,
          onNavigate: !0
        }).forEach((e) => {
          const d = typeof r[e];
          if (e === "as") {
            if (r[e] && d !== "string" && d !== "object")
              throw o({
                key: e,
                expected: "`string` or `object`",
                actual: d
              });
          } else if (e === "locale") {
            if (r[e] && d !== "string")
              throw o({
                key: e,
                expected: "`string`",
                actual: d
              });
          } else if (e === "onClick" || e === "onMouseEnter" || e === "onTouchStart" || e === "onNavigate") {
            if (r[e] && d !== "function")
              throw o({
                key: e,
                expected: "`function`",
                actual: d
              });
          } else if (e === "replace" || e === "scroll" || e === "shallow" || e === "passHref" || e === "legacyBehavior") {
            if (r[e] != null && d !== "boolean")
              throw o({
                key: e,
                expected: "`boolean`",
                actual: d
              });
          } else if (e === "prefetch" && r[e] != null && d !== "boolean" && r[e] !== "auto")
            throw o({
              key: e,
              expected: '`boolean | "auto"`',
              actual: d
            });
        });
      }
      const { href: m, as: u } = c.default.useMemo(() => {
        if (!t) {
          const O = j(l);
          return {
            href: O,
            as: h ? j(h) : O
          };
        }
        const [o, v] = (0, N.resolveHref)(t, l, !0);
        return {
          href: o,
          as: h ? (0, N.resolveHref)(t, h) : v || o
        };
      }, [
        t,
        l,
        h
      ]), A = c.default.useRef(m), U = c.default.useRef(u);
      let a;
      if (f)
        if (process.env.NODE_ENV === "development") {
          E && console.warn('"onClick" was passed to <Link> with `href` of `' + l + '` but "legacyBehavior" was set. The legacy behavior requires onClick be set on the child of next/link'), C && console.warn('"onMouseEnter" was passed to <Link> with `href` of `' + l + '` but "legacyBehavior" was set. The legacy behavior requires onMouseEnter be set on the child of next/link');
          try {
            a = c.default.Children.only(i);
          } catch {
            throw i ? Object.defineProperty(new Error("Multiple children were passed to <Link> with `href` of `" + l + "` but only one child is supported https://nextjs.org/docs/messages/link-multiple-children" + (typeof window < "u" ? ` 
Open your browser's console to view the Component stack trace.` : "")), "__NEXT_ERROR_CODE", {
              value: "E266",
              enumerable: !1,
              configurable: !0
            }) : Object.defineProperty(new Error("No children were passed to <Link> with `href` of `" + l + "` but one child is required https://nextjs.org/docs/messages/link-no-children"), "__NEXT_ERROR_CODE", {
              value: "E320",
              enumerable: !1,
              configurable: !0
            });
          }
        } else
          a = c.default.Children.only(i);
      else if (process.env.NODE_ENV === "development" && i?.type === "a")
        throw Object.defineProperty(new Error(`Invalid <Link> with <a> child. Please remove <a> or use <Link legacyBehavior>.
Learn more: https://nextjs.org/docs/messages/invalid-new-link-with-extra-anchor`), "__NEXT_ERROR_CODE", {
          value: "E209",
          enumerable: !1,
          configurable: !0
        });
      const ue = f ? a && typeof a == "object" && a.ref : s, [H, B, V] = (0, Q.useIntersection)({
        rootMargin: "200px"
      }), ce = c.default.useCallback((o) => {
        (U.current !== u || A.current !== m) && (V(), U.current = u, A.current = m), H(o);
      }, [
        u,
        m,
        V,
        H
      ]), fe = (0, $.useMergedRef)(ce, ue);
      c.default.useEffect(() => {
        process.env.NODE_ENV === "production" && t && (!B || !S || y(t, m, u, {
          locale: _
        }));
      }, [
        u,
        m,
        B,
        _,
        S,
        t?.locale,
        t
      ]);
      const w = {
        ref: fe,
        onClick(o) {
          if (process.env.NODE_ENV !== "production" && !o)
            throw Object.defineProperty(new Error('Component rendered inside next/link has to pass click event to "onClick" prop.'), "__NEXT_ERROR_CODE", {
              value: "E312",
              enumerable: !1,
              configurable: !0
            });
          !f && typeof E == "function" && E(o), f && a.props && typeof a.props.onClick == "function" && a.props.onClick(o), t && (o.defaultPrevented || te(o, t, m, u, P, D, M, _, se));
        },
        onMouseEnter(o) {
          !f && typeof C == "function" && C(o), f && a.props && typeof a.props.onMouseEnter == "function" && a.props.onMouseEnter(o), t && y(t, m, u, {
            locale: _,
            priority: !0,
            // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
            bypassPrefetchedCheck: !0
          });
        },
        onTouchStart: process.env.__NEXT_LINK_NO_TOUCH_START ? void 0 : function(v) {
          !f && typeof k == "function" && k(v), f && a.props && typeof a.props.onTouchStart == "function" && a.props.onTouchStart(v), t && y(t, m, u, {
            locale: _,
            priority: !0,
            // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
            bypassPrefetchedCheck: !0
          });
        }
      };
      if ((0, J.isAbsoluteUrl)(u))
        w.href = u;
      else if (!f || g || a.type === "a" && !("href" in a.props)) {
        const o = typeof _ < "u" ? _ : t?.locale, v = t?.isLocaleDomain && (0, Y.getDomainLocale)(u, o, t?.locales, t?.domainLocales);
        w.href = v || (0, Z.addBasePath)((0, W.addLocale)(u, o, t?.defaultLocale));
      }
      return f ? (process.env.NODE_ENV === "development" && (0, ee.errorOnce)(`\`legacyBehavior\` is deprecated and will be removed in a future release. A codemod is available to upgrade your components:

npx @next/codemod@latest new-link .

Learn more: https://nextjs.org/docs/app/building-your-application/upgrading/codemods#remove-a-tags-from-link-components`), /* @__PURE__ */ c.default.cloneElement(a, w)) : /* @__PURE__ */ (0, L.jsx)("a", {
        ...le,
        ...w,
        children: i
      });
    }), ne = /* @__PURE__ */ (0, c.createContext)({
      // We do not support link status in the Pages Router, so we always return false
      pending: !1
    }), ie = () => (0, c.useContext)(ne), ae = oe;
    (typeof p.default == "function" || typeof p.default == "object" && p.default !== null) && typeof p.default.__esModule > "u" && (Object.defineProperty(p.default, "__esModule", { value: !0 }), Object.assign(p.default, p), K.exports = p.default);
  })(q, q.exports), q.exports);
}
export {
  Ke as __require
};
//# sourceMappingURL=index.es189.js.map
